import RastreadoresView from "@/views/Rastreadores.vue";

const rastreadores = {
  path: "/app/rastreadores",
  name: "rastreadores",
  component: RastreadoresView
};

export default rastreadores;
